<template>
  <div class="header" id="skeleton-header">
    <a class="logo-wrapper" href="/desktop">
      <img
        class="logo"
        v-if="userInfo.schoolLogo && !textbook.isInIframe"
        :src="userInfo.schoolLogo"
        alt=""
      />
      <!-- defaultFaceImg @/assets/images/logo.png -->

      <img
        v-if="!userInfo.schoolLogo && !textbook.isInIframe"
        class="logo"
        src="@/assets/images/logo.png"
        alt=""
      />
      <span class="logo-name" v-if="!textbook.isInIframe">{{
        userInfo.schoolName
      }}</span>
    </a>

    <SwitchCourses
      v-if="
        $route.path.indexOf('/school-based') === -1 &&
        $route.path.indexOf('/search/result') === -1 &&
        $route.path.indexOf('/after-service') === -1 &&
        $route.path.indexOf('/tech') === -1
      "
      @changeAddCourseDialogVisible="changeAddCourseDialogVisible"
    />

    <div class="tip">
      <!-- <a
        class="back-old-site"
        v-if="!textbook.isInIframe"
        href="https://wxt.zxxk.com/"
        target="_blank"
      >
        <i class="iconfont icon-fanhui"></i>
        返回旧版
      </a> -->
      <TopNavSearch />
      <!-- <el-dropdown @command="handleHelp" trigger="click">
        <span
          class="el-dropdown-link al-tooltip"
          tooltip="帮助"
          position="bottom"
          theme="dark"
        >
          <i class="iconfont icon-bangzhu"></i>
        </span>
        <el-dropdown-menu slot="dropdown"> -->
      <!-- <el-dropdown-item command="a"
            ><i class="iconfont icon-customer"></i>在线客服
          </el-dropdown-item>
          <el-dropdown-item command="b"
            ><i class="iconfont icon-help"></i>帮助中心</el-dropdown-item
          >
          <el-dropdown-item command="c"
            ><i class="iconfont icon-feedback"></i>产品反馈</el-dropdown-item
          > -->
      <!-- <el-dropdown-item command="d"
        ><i class="iconfont icon-diary"></i>更新日志</el-dropdown-item
      > -->
      <!-- <el-dropdown-item command="e"
            ><i class="iconfont icon-home"></i
            >访问官网</el-dropdown-item
          > -->
      <!-- </el-dropdown-menu>
      </el-dropdown> -->
      <!-- <el-dropdown
        style="margin-right: 10px"
        @command="handleCommand"
        trigger="click"
      >
        <span
          class="el-dropdown-link al-tooltip"
          tooltip="通知"
          position="bottom"
          theme="dark"
          data-io-click="tracker"  @click="tongzhiDialogVisible = true"
        >
          <i class="iconfont icon-tongzhi"><i class="reddot">12</i></i>
        </span>
        <el-dropdown-menu></el-dropdown-menu>
      </el-dropdown> -->
      <el-dropdown @command="handleCommand" trigger="click">
        <div class="portrait">
          <img :src="userInfo.faceImg || defaultFaceImg" alt="" /><span
            class="mask"
            >...</span
          >
        </div>
        <el-dropdown-menu class="user-info" slot="dropdown">
          <div class="identity">
            <img
              class="pic"
              :src="userInfo.faceImg || defaultFaceImg"
              :alt="userInfo.nickName"
            />
            <div class="name">{{ userInfo.nickName }}</div>
            <div class="house">你的线上教研室</div>
          </div>
          <div class="school">
            <span class="key">学校：</span>
            <span class="value">{{ userInfo.schoolName }}</span>
          </div>
          <div class="service">
            <span class="key">服务：</span>
            <span
              class="value"
              v-for="(item, index) in userInfo.roles"
              :key="index"
            >
              <i class="high">{{ item.roleName }}</i
              >（剩余<i class="high">{{ item.validDays }}</i
              >天）
            </span>
          </div>
          <div class="menu">
            <span v-if="!textbook.isInIframe" data-io-click="tracker"  @click="toService" class="item"
              ><i class="iconfont icon-customer"></i>在线客服</span
            >
            <a
              href="https://mxkw.yuque.com/docs/share/0a6b57f3-e550-420a-8236-c5e9dde5d468"
              target="_blank"
              class="item"
              ><i class="iconfont icon-help"></i>帮助文档</a
            >
            <span
              class="item"
              v-if="!textbook.isInIframe"
              data-io-click="tracker"  @click="$emit('changeFeedbackDialogVisible', true)"
              ><i class="iconfont icon-feedback"></i>问题反馈</span
            >
            <span class="item" data-io-click="tracker"  @click="$emit('changeRizhiDialogVisible', true)">
              <i class="iconfont icon-diary"></i>更新日志
            </span>
            <a
              href="https://account.xkw.com"
              v-if="!textbook.isInIframe"
              target="_blank"
              class="item"
              ><i class="iconfont icon-author"></i>账号设置</a
            >
            <span class="item" data-io-click="tracker"  @click="openSetting"
              ><i class="iconfont icon-setting"></i>偏好设置</span
            >
            <!-- v-if="userInfo.isAdmin" -->
            <a
              v-if="userInfo.isAdmin"
              href="//admin-wxt.xkw.com"
              target="_blank"
              class="item"
              ><i class="iconfont icon-quanxianguanli"></i>权限管理</a
            >
            <a
              v-if="userInfo.isAdmin"
              href="https://ss.xkw.com"
              target="_blank"
              class="item"
              ><i class="iconfont icon-mangement"></i>管理后台</a
            >
          </div>
          <a class="quit" v-if="!textbook.isInIframe" :href="logoutUrl"
            ><i class="iconfont icon-quit"></i>退出登录</a
          >
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div
      class="mask"
      v-if="isShowMask"
      :style="maskStyle"
      data-io-click="tracker"  @click="noticeChildPageShowMask"
    ></div>
    <!-- <div class="nav">
      <span class="tips" v-show="isShowTips">
        期待您的宝贵建议~
        <i class="close" data-io-click="tracker"  @click="isShowTips = false">×</i>
      </span>
    </div> -->
    <el-dialog
      custom-class="tongzhi"
      :visible.sync="tongzhiDialogVisible"
      width="62.5%"
      center
    >
      <div slot="title" class="dialog-title">
        <span class="tabBtn" data-io-click="tracker"  @click="showNotice = [1, 0, 0]">全部通知</span>
        <span>/</span>
        <span class="tabBtn" data-io-click="tracker"  @click="showNotice = [0, 1, 0]">系统通知</span>
        <span>/</span>
        <span class="tabBtn" data-io-click="tracker"  @click="showNotice = [0, 0, 1]">资源通知</span>
      </div>
      <div v-if="showNotice[0]">1</div>
      <div v-if="showNotice[1]">2</div>
      <div v-if="showNotice[2]">3</div>
    </el-dialog>
    <!-- <timeLineModal  v-if="rizhiDialogVisible" :rizhiDialogVisible="rizhiDialogVisible"/>
    <feedBackModal
      @closeModal="feedbackDialogVisible = false"
      type="建议"
      v-if="feedbackDialogVisible"
      :feedbackDialogVisible="feedbackDialogVisible"
    ></feedBackModal> -->
  </div>
</template>
<script>
import suggestion from "@/assets/js/mixin/suggestion";
import api from "@/assets/js/service/api";
import feedBackModal from "@/components/feedBackModal";
import SwitchCourses from "@/components/SwitchCourses.vue";
import timeLineModal from "@/components/timeLineModal";
import TopNavSearch from "@/components/TopNavSearch.vue";
import { beikeHost } from "@/utils/apis";
import { defaultFaceImg } from "@/utils/stateList.js";
import { mapMutations, mapState } from "vuex";
const CURRENTCOURSE = "CURRENTCOURSE";
export default {
  components: {
    // MescrollVue,
    feedBackModal,
    timeLineModal,
    SwitchCourses,
    TopNavSearch,
  },
  mixins: [suggestion],
  inject: ["textbook"],
  data() {
    return {
      logoutUrl: api.auth.logout + `?curl=https://${window.location.host}/`,
      defaultFaceImg: defaultFaceImg,
      tongzhiDialogVisible: false,
      rizhiDialogVisible: false,
      feedbackDialogVisible: false,
      showNotice: [true, false, false],
      feedbacktabArr: [1, 0, 0],
      typeArr: [],
      mescroll: null, // mescroll实例对象
      mescrollDown: {}, //下拉刷新的配置. (如果下拉刷新和上拉加载处理的逻辑是一样的,则mescrollDown可不用写了)
      mescrollUp: {
        // 上拉加载的配置.
        callback: this.upCallback, // 上拉回调,此处简写; 相当于 callback: function(page, mescroll) { }
      },
      // 需要上传的图片
      uploadImgs: [],
      set: "11",
      feedBackTypes: {},
      loading: false,
      isNoMore: false,
    };
  },
  props: {
    isShowMask: {
      type: Boolean,
      default: false,
    },
    maskStyle: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapState({
      userInfo: "userInfo",
    }),
  },
  methods: {
    ...mapMutations({
      setCurrentCourse: "setCurrentCourse",
    }),
    getCurrentCourse() {
      let currentCourse = localStorage.getItem(
        `${this.userInfo.userId}-` + CURRENTCOURSE
      );
      if (currentCourse) {
        // console.log();
      }
    },
    changeAddCourseDialogVisible(e) {
      // console.log('e',e)
      this.$emit("changeAddCourseDialogVisible", e);
    },
    // 监听滚动
    handleFeedbackList(e) {},
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    noticeChildPageShowMask() {
      this.textbook.noticeChildPageShowMask();
    },
    handleHelp(command) {
      // this.$message("click on item " + command);
      switch (command) {
        case "a":
          this.toService();
          break;
        case "b":
          window.open("https://www.zxxk.com/service/ ");
          break;
        case "c":
          // 显示意见反馈弹窗
          this.$emit("changeFeedbackDialogVisible", true);
          break;
        case "d":
          this.$emit("changeRizhiDialogVisible", true);
          break;
        case "e":
          window.open("https://wxt.zxxk.com/introduce/");
          break;
      }
    },
    toService() {
      window.open(
        "https://webchat-bj.clink.cn/chat.html?accessId=b99757dc-4d2a-4219-83bb-46289b108c8a&tinetWebChatType=tinetResponsive&language=zh_CN"
      );
    },
    // 打开偏好设置
    openSetting() {
      this.$emit("openSetting");
    },
    handleCommand() {},
    handleClick(tab, event) {},
  },
  mounted() {
    // let url = "https://wxt.xkw.com?curl=https://wxt.xkw.com/";
    let url = `https://${window.location.host}/wxtapi/auth/logout?curl=http://${window.location.host}/`;
    let lastUrl =
      `https://${beikeHost}/ibook/users/logout?logout_sso=true&url=` +
      encodeURIComponent(url);
    this.logoutUrl = lastUrl;
    // console.log(this.$route);
    // this.firstOpen();
  },
};
</script>
<style lang="scss" scoped>
.header {
  position: fixed;
  top: 0;
  z-index: 13;
  width: 100%;
  padding: 0 28px;
  height: 62px;
  background: #fff;
  box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.03);

  .nav {
    position: relative;
    float: right;
    padding-top: 20px;
    line-height: 62px;
    font-size: 14px;
    color: #333;

    .item {
      float: left;
      padding: 0 6px;
      height: 22px;
      line-height: 22px;
      margin-right: 20px;
      cursor: pointer;

      &:hover {
        background: #eff1f4;
        border-radius: 4px;
        color: #0057ff;

        .iconfont {
          color: #0057ff;
        }
      }
    }

    .tips {
      position: absolute;
      right: 25px;
      top: 49px;
      padding: 0 0 0 15px;
      height: 34px;
      line-height: 34px;
      background: rgba(0, 0, 0, 1);
      border-radius: 8px 0px 8px 8px;
      font-size: 13px;
      color: #fff;
      opacity: 0.6;

      .close {
        display: inline-block;
        width: 34px;
        height: 34px;
        font-style: normal;
        line-height: 34px;
        text-align: center;
        cursor: pointer;
        font-size: 14px;
        vertical-align: top;

        &:hover {
          color: #0057ff;
        }
      }
    }

    .iconfont {
      margin-right: 6px;
      font-size: 14px;
      color: #333;
    }
  }

  .mask {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    z-index: 50;
  }

  .tip {
    line-height: 60px;
    float: right;

    > * {
      float: left;
    }

    i {
      // float: left;
      margin: 0 10px;
      font-size: 18px;
    }

    img {
      fill: blue;
    }

    .portrait {
      position: relative;
      height: 36px;
      width: 36px;
      margin-top: 12px;
      border-radius: 18px;
      overflow: hidden;
      cursor: pointer;

      img {
        display: block;
        width: 100%;
        height: 100%;
      }

      .mask {
        position: absolute;
        height: 100%;
        width: 100%;
        top: 0;
        left: 0px;
        background: rgba(0, 0, 0, 0.5);
        line-height: 27px;
        color: #fff;
        letter-spacing: 3px;
        font-weight: bold;
        text-align: center;
        text-indent: 3px;
        opacity: 0;

        &:hover {
          opacity: 1;
        }
      }
    }

    .back-old-site {
      margin-right: 14px;
      font-size: 14px;
      color: #666;

      i {
        margin-right: 0;
      }

      &:hover {
        color: #0057ff;

        i {
          background: transparent;
        }
      }
    }
  }

  &::v-deep .tongzhi {
    height: 840px;
    margin-top: 60px !important;
  }

  &::v-deep .rizhi {
    width: 708px !important;
    min-height: 620px;
    margin-top: 160px !important;

    .el-dialog__body {
      height: 500px;
      overflow: auto;
      overflow-x: hidden;
    }
  }
}

.el-popper {
  margin-top: -4px !important;
  padding: 0 0 !important;
}

.el-dropdown-menu__item:hover {
  color: #0057ff;
  background: #eff1f4;
}

.el-dropdown-menu__item {
  line-height: 42px;
}

.iconfont {
  cursor: pointer;

  &:hover {
    color: #0057ff;
    background: #eff1f4;
  }
}

.al-tooltip {
  position: relative;
}

.al-tooltip:hover::before {
  display: block;
}

.al-tooltip:hover::after {
  display: block;
}

.al-tooltip::before {
  display: none;
  content: attr(tooltip);
  position: absolute;
  white-space: nowrap;
  border-radius: 5px;
  z-index: 100;
  width: 36px;
  height: 18px;
  line-height: 16px;
  color: #fff;
  background-color: #000;
  text-align: center;
  font-size: 12px;
  line-height: 18px;
}

.al-tooltip[position="bottom"]::before {
  top: calc(100%);
  left: 50%;
  transform: translate(-50%);
  animation: ani-bottom 0.3s ease-out;
  box-shadow: 0 -5px 10px -2px rgba(0, 0, 0, 0.4);
}

.al-tooltip::after {
  display: none;
  content: "";
  position: absolute;
  z-index: 100;
  width: 0;
  height: 0;
}

.al-tooltip[position="bottom"]::after {
  animation: ani-bottom 0.3s ease-out;
  top: 15px;
  left: 50%;
  transform: translate(-50%);
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 5px solid #fff;
}

.al-tooltip[theme="dark"]::before {
  color: #fff;
  background-color: #000;
}

.al-tooltip[theme="dark"][position="top"]::after {
  border-top-color: #000;
}

.al-tooltip[theme="dark"][position="right"]::after {
  border-right-color: #000;
}

.al-tooltip[theme="dark"][position="bottom"]::after {
  border-bottom-color: #000;
}

.al-tooltip[theme="dark"][position="left"]::after {
  border-left-color: #000;
}

.el-dialog__body {
  border-right: 1px solid gray;
}

.portrait2 {
  margin-right: 10px;

  img {
    width: 36px;
    height: 36px;
    border-radius: 18px;
  }
}

::v-deep .el-dropdown {
  margin-left: 14px;
}

.user-info {
  min-width: 242px;
  max-width: 300px;
  top: 62px !important;
  border-radius: 0 0 4px 4px;

  .identity {
    position: relative;
    padding: 19px 0 0 63px;

    .pic {
      position: absolute;
      top: 19px;
      left: 17px;
      width: 36px;
      height: 36px;
      border-radius: 100%;
    }

    .name {
      margin-top: 2px;
      display: block;
      height: 14px;
      font-size: 14px;
      color: #333;
      line-height: 14px;
    }

    .house {
      margin-top: 7px;
      display: block;
      height: 12px;
      font-size: 12px;
      color: #80848b;
      line-height: 12px;
    }
  }

  .school,
  .service {
    position: relative;
    padding-left: 59px;
    margin-top: 18px;
    line-height: 20px;
    font-size: 14px;

    .key {
      position: absolute;
      left: 17px;
      top: 0;
      color: #80848b;
    }

    .value {
      display: block;
      color: #333;
    }

    .high {
      color: #ff6b00;
      font-style: normal;
    }
  }

  .service {
    margin-top: 8px;
  }

  .menu {
    margin: 17px 0 0;
    position: relative;

    &:before {
      position: absolute;
      left: 8px;
      right: 8px;
      top: 0;
      content: "";
      height: 1px;
      background: #e6e7e9;
    }

    .item {
      display: block;
      padding-left: 18px;
      position: relative;
      height: 42px;
      font-size: 14px;
      color: #333;
      line-height: 42px;
      cursor: pointer;

      .iconfont {
        margin-right: 10px;
        font-size: 16px;
        color: #80848b;
      }

      &:hover {
        color: #0057ff;
        background: #eff1f4;

        .iconfont {
          color: #0057ff;
        }
      }

      &:nth-child(4) {
        &::after {
          position: absolute;
          left: 8px;
          right: 8px;
          bottom: 0;
          content: "";
          height: 1px;
          background: #e6e7e9;
        }
      }
    }
  }

  .quit {
    display: block;
    margin-top: 12px;
    margin-bottom: 4px;
    padding-left: 18px;
    height: 42px;
    line-height: 42px;
    color: #80848b;
    cursor: pointer;
    font-size: 14px;

    .iconfont {
      margin-right: 10px;
    }

    &:hover {
      background: #eff1f4;
    }
  }
}

.reddot {
  position: absolute;
  background: #f56b56;
  width: 16px;
  height: 16px;
  border-radius: 8px;
  font-size: 12px !important;
  color: #fff;
  left: 0px;
  line-height: 17px;
  top: -8px;
}

.icon-tongzhi {
  position: relative;
}

.logo-wrapper {
  float: left;
  // max-width: 300px;
  height: 38px;
  margin-top: 12px;
  margin-right: 25px;

  // position: relative;
  .logo {
    // position: absolute;
    // top: 0;
    // left: 0;
    width: 94px;
    height: 100%;
  }

  .logo-name {
    font-size: 13px;
    color: #666666;
    margin-left: -60px;
    vertical-align: -12px;
  }
}

.no-school-logo {
  float: left;
  height: 31px;
  margin-top: 16px;
  width: 99px;
}

::v-deep .feedback {
  height: 512px;
  font-size: 14px;

  .tabheader > span {
    font-size: 16px;
  }

  .tabheader > span.active {
    color: #0057ff;
  }

  .lb {
    margin-right: 11px;
    line-height: 28px;
  }

  .el-textarea {
    width: 609px;
  }

  .type > * {
    float: left;
    margin-bottom: 20px;
  }

  .shangchuantupian {
    font-size: 30px;
  }

  .el-upload-list--picture-card .el-upload-list__item {
    width: 90px;
    height: 90px;
  }

  .upload {
    padding-left: 42px;
  }

  .el-upload--picture-card {
    width: 90px;
    height: 90px;
    position: relative;
  }

  .shangchuantupian,
  .texttip {
    position: absolute;
  }

  .shangchuantupian {
    left: 29px;
    top: 24px;
  }

  .texttip {
    font-size: 12px;
    color: #999;
    height: 12px;
    line-height: 12px;
    top: 62px;
    left: 20px;
  }

  .submit {
    width: 132px;
    height: 42px;
    background: #0057ff;
    color: #fff;
    border: none;
    border-radius: 21px;
    cursor: pointer;
    position: absolute;
    right: 20px;
    bottom: 20px;
  }

  .el-radio__inner,
  .el-radio__input,
  .el-radio__original {
    display: none;
  }

  .el-radio__label {
    padding-left: 0;
  }

  .el-radio--mini.is-bordered {
    padding: 6px 15px 0 15px;
    border-radius: 25px;
  }

  .el-radio.is-bordered.is-checked {
    background-color: #e5f7fe;
    border-color: #0057ff;
    color: #0057ff;
  }

  .el-upload--picture-card:hover {
    opacity: 0.8;
  }

  .el-upload:focus {
    border-color: #c0ccda;
  }

  .el-radio {
    margin-left: 0px !important;
  }

  .list-content {
    color: #333;
    line-height: 30px;
    height: 420px;

    li {
      border-bottom: 1px solid #e6e7e9;
      padding-bottom: 12px;
      padding-top: 12px;
    }

    li > div {
      > * {
        margin-right: 20px;
      }
    }
  }

  .el-dialog__body {
    padding: 0;
    overflow: auto;
    height: 420px;
  }

  .nothing {
    text-align: center;
    margin-top: 100px;
    img {
      width: 120px;
    }
  }

  .fbdail {
    padding: 18px 0 0 24px;
    line-height: 14px;

    > div {
      margin-bottom: 18px;

      span {
        margin-right: 16px;
      }
    }

    .imgbox {
      img {
        float: left;
        border: 1px solid #bebebe;
        margin-right: 16px;
      }
    }

    .fbfooter {
      font-size: 12px;
      background: #f9df91;
      text-align: center;
      height: 33px;
      line-height: 33px;
      position: absolute;
      left: 0;
      bottom: 0;
      width: 708px;
      margin: 0;
      border-radius: 0 0 8px 8px;
    }
  }
}
</style>
